import {Injectable} from '@angular/core';

export interface CachedImage {
  url: string;
  blob: Blob | null;
}

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  cachedImages: CachedImage[] = [];

  

  checkAndCacheImage(url: string, blob: Blob | null) {
    if (!this.cachedImages.find(image => image.url === url)) {
      this.cachedImages.push({url, blob});
    }
  }
}
